const serverConfig = {
  baseURL: 'https://nb.p6f.cn'
}
export default serverConfig
